@if (redirectPreloaderService.redirecting.preloader) {
  <div class="redirecting-preloader">
    <div class="redirecting-preloader-background"></div>
    <libero-preload-spinner></libero-preload-spinner>
  </div>
}

<div class="login-page">
  <div class="login-background">
    <div class="logo-container">
      <svg-icon src="assets/logo/logo-white.svg" [svgStyle]="{ 'width.px':330 }"></svg-icon>
    </div>
    <div class="logo-desc">
      {{ 'login.underLogoDescription' | translate }}
    </div>

    <div class="login-buttons-container">
      <a class="login-consult-link" href="{{ bwmClientAppUrl }}" data-cy="login-btn-consult">
        {{ 'login.workplaceLogin' | translate }}
      </a>
    </div>

    <div class="login-background-mask"></div>
  </div>
</div>